import { Allergen } from "./Allergen.js";
import type { AllergenData } from "./AllergenData.js";
import { Locale } from "./Locale.js";

/**
 * Zdroje:
 * - směrnice EU 1169/11 (https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2011:304:0018:0063:CS:PDF)
 * - https://www.nzip.cz/clanek/364-povinne-oznacovani-potravin-obsahujicich-alergeny
 */

/**
 * Please, keep order of entries.
 */

export const allergensDataMap: Record<Allergen, AllergenData> = {
	[Allergen.CerealsContainingGluten]: {
		allergen: Allergen.CerealsContainingGluten,
		orderLabel: "1",
		name: {
			[Locale.cs]: "Obiloviny obsahující lepek",
		},
		description: {
			[Locale.cs]: "pšenice, žito, ječmen, oves, špalda, kamut nebo jejich odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenWheat]: {
		allergen: Allergen.CerealsContainingGlutenWheat,
		orderLabel: "1a",
		name: {
			[Locale.cs]: "Pšenice",
		},
		description: {
			[Locale.cs]: "nebo její odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenRye]: {
		allergen: Allergen.CerealsContainingGlutenRye,
		orderLabel: "1b",
		name: {
			[Locale.cs]: "Žito",
		},
		description: {
			[Locale.cs]: "nebo jeho odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenBarley]: {
		allergen: Allergen.CerealsContainingGlutenBarley,
		orderLabel: "1c",
		name: {
			[Locale.cs]: "Ječmen",
		},
		description: {
			[Locale.cs]: "nebo jeho odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenOats]: {
		allergen: Allergen.CerealsContainingGlutenOats,
		orderLabel: "1d",
		name: {
			[Locale.cs]: "Oves",
		},
		description: {
			[Locale.cs]: "nebo jeho odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenSpelt]: {
		allergen: Allergen.CerealsContainingGlutenSpelt,
		orderLabel: "1e",
		name: {
			[Locale.cs]: "Špalda",
		},
		description: {
			[Locale.cs]: "nebo její odrůdy",
		},
	},
	[Allergen.CerealsContainingGlutenKamut]: {
		allergen: Allergen.CerealsContainingGlutenKamut,
		orderLabel: "1f",
		name: {
			[Locale.cs]: "Kamut",
		},
		description: {
			[Locale.cs]: "nebo jeho odrůdy",
		},
	},
	[Allergen.Crustaceans]: {
		allergen: Allergen.Crustaceans,
		orderLabel: "2",
		name: {
			[Locale.cs]: "Korýši",
		},
	},
	[Allergen.Egg]: {
		allergen: Allergen.Egg,
		orderLabel: "3",
		name: {
			[Locale.cs]: "Vejce",
		},
	},
	[Allergen.Fish]: {
		allergen: Allergen.Fish,
		orderLabel: "4",
		name: {
			[Locale.cs]: "Ryby",
		},
	},
	[Allergen.Peanut]: {
		allergen: Allergen.Peanut,
		orderLabel: "5",
		name: {
			[Locale.cs]: "Arašídy",
		},
	},
	[Allergen.Soybeans]: {
		allergen: Allergen.Soybeans,
		orderLabel: "6",
		name: {
			[Locale.cs]: "Sójové boby",
		},
	},
	[Allergen.Milk]: {
		allergen: Allergen.Milk,
		orderLabel: "7",
		name: {
			[Locale.cs]: "Mléko",
		},
		description: {
			[Locale.cs]: "včetně laktózy",
		},
	},
	[Allergen.Nuts]: {
		allergen: Allergen.Nuts,
		orderLabel: "8",
		name: {
			[Locale.cs]: "Skořápkové plody",
		},
		description: {
			[Locale.cs]: "lískové, vlašské, kešu, pekanové, para a makadamové ořechy, dále pistácie a mandle",
		},
	},
	[Allergen.NutsAlmond]: {
		allergen: Allergen.NutsAlmond,
		orderLabel: "8a",
		name: {
			[Locale.cs]: "Mandle",
		},
	},
	[Allergen.NutsHazelnut]: {
		allergen: Allergen.NutsHazelnut,
		orderLabel: "8b",
		name: {
			[Locale.cs]: "Lískové ořechy",
		},
	},
	[Allergen.NutsWalnut]: {
		allergen: Allergen.NutsWalnut,
		orderLabel: "8c",
		name: {
			[Locale.cs]: "Vlašské ořechy",
		},
	},
	[Allergen.NutsCashew]: {
		allergen: Allergen.NutsCashew,
		orderLabel: "8d",
		name: {
			[Locale.cs]: "Kešu ořechy",
		},
	},
	[Allergen.NutsPecan]: {
		allergen: Allergen.NutsPecan,
		orderLabel: "8e",
		name: {
			[Locale.cs]: "Pekanové ořechy",
		},
	},
	[Allergen.NutsBrazilNut]: {
		allergen: Allergen.NutsBrazilNut,
		orderLabel: "8f",
		name: {
			[Locale.cs]: "Para ořechy",
		},
	},
	[Allergen.NutsPistachios]: {
		allergen: Allergen.NutsPistachios,
		orderLabel: "8g",
		name: {
			[Locale.cs]: "Pistácie",
		},
	},
	[Allergen.NutsMacadamia]: {
		allergen: Allergen.NutsMacadamia,
		orderLabel: "8h",
		name: {
			[Locale.cs]: "Makadamie",
		},
	},
	[Allergen.Celery]: {
		allergen: Allergen.Celery,
		orderLabel: "9",
		name: {
			[Locale.cs]: "Celer",
		},
	},
	[Allergen.Mustard]: {
		allergen: Allergen.Mustard,
		orderLabel: "10",
		name: {
			[Locale.cs]: "Hořcice",
		},
	},
	[Allergen.Sesame]: {
		allergen: Allergen.Sesame,
		orderLabel: "11",
		name: {
			[Locale.cs]: "Sezamová semínka",
		},
	},
	[Allergen.SulphurDioxideAndSulphurites]: {
		allergen: Allergen.SulphurDioxideAndSulphurites,
		orderLabel: "12",
		name: {
			[Locale.cs]: "Oxid siřičitý a siřičitany",
		},
		description: {
			[Locale.cs]: "od 10 mg/kg nebo 10 mg/l",
		},
	},
	[Allergen.Lupin]: {
		allergen: Allergen.Lupin,
		orderLabel: "13",
		name: {
			[Locale.cs]: "Vlčí bob",
		},
		description: {
			[Locale.cs]: "lupina mnoholistá (lat. Lupinus polyphyllus)",
		},
	},
	[Allergen.Molluscs]: {
		allergen: Allergen.Molluscs,
		orderLabel: "14",
		name: {
			[Locale.cs]: "Měkkýši",
		},
		description: {
			[Locale.cs]: "např. hlemýždi, mušle, chobotnice",
		},
	},
};
